import JobZImage from "../../../common/jobz-img";
import { loadScript } from "../../../../globals/constants";
import { useEffect, useState } from "react";
import { jobService } from "../../../../services/job-service";

function CanCVManagerPage() {
    const [resumes, setResumes] = useState([]);
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(true);
    const [uploading, setUploading] = useState(false);

    const load = () => {
        setLoading(true);
        jobService.resumes()
            .then((data) => setResumes(data.resumes || []))
            .catch((error) => setMessage(error.message))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        loadScript("js/custom.js");
        load();
    }, []);

    const upload = async (event) => {
        event.preventDefault();
        if (!file) {
            setMessage("Choose a resume file first.");
            return;
        }
        setUploading(true);
        setMessage("");
        try {
            await jobService.uploadResume(file);
            setFile(null);
            setMessage("Resume uploaded to R2.");
            load();
        } catch (error) {
            setMessage(error.message);
        } finally {
            setUploading(false);
        }
    };

    const remove = async (id) => {
        try {
            await jobService.deleteResume(id);
            setMessage("Resume deleted.");
            load();
        } catch (error) {
            setMessage(error.message);
        }
    };

    return (
        <>
            <div className="twm-right-section-panel candidate-save-job site-bg-gray">
                <div className="product-filter-wrap d-flex justify-content-between align-items-center">
                    <span className="woocommerce-result-count-left">CV Manager</span>
                </div>

                <form onSubmit={upload} className="m-b30">
                    <div className="row">
                        <div className="col-md-8">
                            <input className="form-control" type="file" accept=".pdf,.doc,.docx" onChange={(event) => setFile(event.target.files?.[0] || null)} />
                        </div>
                        <div className="col-md-4">
                            <button type="submit" disabled={uploading} className="site-button">{uploading ? "Uploading..." : "Upload CV"}</button>
                        </div>
                    </div>
                </form>

                {message && <div className="alert alert-info">{message}</div>}
                {loading ? (
                    <div className="p-a30 text-center">Loading resumes...</div>
                ) : (
                    <div className="twm-cv-manager-list-wrap">
                        {resumes.length === 0 ? (
                            <div className="p-a30 text-center">No resumes uploaded yet.</div>
                        ) : (
                            <ul>
                                {resumes.map((resume, index) => (
                                    <li key={resume.id}>
                                        <div className="twm-cv-manager-list-style1">
                                            <div className="twm-media">
                                                <div className="twm-media-pic">
                                                    <JobZImage src={`images/candidates/pic${(index % 5) + 1}.jpg`} alt="#" />
                                                </div>
                                            </div>
                                            <div className="twm-mid-content">
                                                <h4>{resume.file_name}</h4>
                                                <p>{resume.content_type || "Uploaded file"}</p>
                                                <div className="twm-fot-content">
                                                    <div className="twm-left-info">
                                                        <div className="twm-job-post-duration">{formatDate(resume.created_at)}</div>
                                                        <div className="twm-candidates-tag"><span>{formatBytes(resume.size)}</span></div>
                                                    </div>
                                                    <div className="twm-view-button">
                                                        {resume.download_url && (
                                                            <a href={resume.download_url} target="_blank" rel="noreferrer" className="site-button-link site-text-primary m-r15" title="View Resume">
                                                                <i className="fa fa-eye" /> View
                                                            </a>
                                                        )}
                                                        <button type="button" title="Delete" className="text-danger" style={{ border: "none", background: "none" }} onClick={() => remove(resume.id)}>
                                                            <i className="fa fa-trash-alt" /> Delete
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                )}
            </div>
        </>
    )
}

function formatDate(value) {
    if (!value) return "";
    return new Date(value).toLocaleDateString();
}

function formatBytes(value) {
    const bytes = Number(value || 0);
    if (!bytes) return "Unknown size";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

export default CanCVManagerPage;
